import { createFileRoute } from '@tanstack/react-router';
import { DocumentsPublic } from '@/components/DocumentsPublic';

export const Route = createFileRoute('/_auth/documents/')({
  component: DocumentsRoute,
});

function DocumentsRoute() {
  return <DocumentsPublic />;
}
